<template lang="html">
  <v-content>
    <v-dialog
      width="700"
      v-model="editTaskDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="editTaskDialogOpened = false"
      @keydown.enter="addComment()"
      persistent
    >
      <v-card v-if="selectedTask">
        <v-card-title class="title pb-0">
          <span>Edit Task</span>
          <v-spacer />
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              fab
              small
              flat
              class="white darkgrey--text text-capitalize ma-0 ml-1"
              @click="deleteTask()"
            >
              <v-icon size="25"> delete_outline </v-icon>
            </v-btn>
            <span>Delete Task</span>
          </v-tooltip>
          <v-btn
            fab
            small
            flat
            class="white error--text text-capitalize ma-0 ml-1"
            @click="editTaskDialogOpened = false"
          >
            <v-icon size="25"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-xs-left">
          <v-layout wrap>
            <v-flex xs12>
              <div class="darkgrey--text">Task Name</div>
              <v-text-field
                v-model="selectedTask.title"
                hide-details
                solo
                placeholder="Task name"
                class="default-input mb-4"
              />
            </v-flex>
            <v-flex xs6 class="pr-2">
              <div class="darkgrey--text">Status</div>
              <v-select
                v-model="selectedTask.status"
                hide-details
                solo
                :items="taskStatuses"
                class="default-input mb-4"
              />
            </v-flex>
            <v-flex xs6 class="pl-2">
              <div class="darkgrey--text">Assigned Team Member</div>
              <v-select
                v-model="selectedTask.assigned_user"
                placeholder="Assign a team member"
                hide-details
                solo
                :items="users"
                class="default-input mb-4"
              />
            </v-flex>
            <v-flex xs6 class="pr-2">
              <div class="darkgrey--text">Tag</div>
              <v-select
                v-model="selectedTask.tag"
                placeholder="Select tag"
                hide-details
                solo
                :items="tags"
                class="default-input mb-4"
              />
            </v-flex>
            <v-flex xs6 class="pl-2">
              <div class="darkgrey--text">Due Date</div>
              <v-text-field
                class="default-input"
                type="date"
                solo
                hide-details
                v-model="selectedTask.due_date"
                placeholder="Choose a due date"
              />
            </v-flex>
            <v-flex xs12>
              <div class="darkgrey--text mb-1">Comments</div>
              <v-layout
                column
                class="pa-2 grey lighten-4"
                v-if="!isEmpty(selectedTask.comments)"
              >
                <v-layout
                  wrap
                  align-center
                  v-for="(comment, i) in selectedTask.comments"
                  :key="i"
                  class="my-1"
                >
                  <span class="font-weight-bold mr-1">{{ comment.user }}:</span
                  ><span class="darkgrey--text text--darken-1">{{
                    comment.text
                  }}</span>
                  <v-spacer />
                  <span class="grey--text">{{ comment.date }}</span>
                  <v-tooltip class="ml-1" bottom>
                    <v-icon
                      slot="activator"
                      v-if="comment.user === currentUser.full_name"
                      color="error"
                      size="15"
                      @click="selectedTask.comments.splice(i, 1)"
                      style="cursor: pointer"
                    >
                      clear
                    </v-icon>
                    <span>Delete Comment</span>
                  </v-tooltip>
                </v-layout>
              </v-layout>
              <div v-else class="my-1 grey--text">None</div>
              <v-layout align-center>
                <v-text-field
                  v-model="newComment"
                  hide-details
                  solo
                  placeholder="Add a comment"
                  class="default-input"
                />
                <v-btn
                  @click="addComment()"
                  class="default-input primary text-capitalize mr-0"
                  :disabled="isEmpty(newComment)"
                >
                  Add
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      width="700"
      v-model="createTaskDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="createTaskDialogOpened = false"
      @keydown.enter="createTask()"
      persistent
    >
      <v-card v-if="selectedTask">
        <v-card-title class="title pb-0">
          <span>Create Task</span>
          <v-spacer />
          <span class="caption error--text">*Required</span>
        </v-card-title>
        <v-card-text class="text-xs-left">
          <v-layout wrap>
            <v-flex xs12>
              <div class="darkgrey--text">
                Task Name<span class="error--text ml-1">*</span>
              </div>
              <v-text-field
                v-model="selectedTask.title"
                solo
                :rules="existRule"
                placeholder="Task name"
                class="default-input"
              />
            </v-flex>
            <v-flex xs6 class="pr-2">
              <div class="darkgrey--text">
                Status<span class="error--text ml-1">*</span>
              </div>
              <v-select
                v-model="selectedTask.status"
                :rules="existRule"
                placeholder="Select a status"
                solo
                :items="taskStatuses"
                class="default-input"
              />
            </v-flex>
            <v-flex xs6 class="pl-2">
              <div class="darkgrey--text">Assigned Team Member</div>
              <v-select
                v-model="selectedTask.assigned_user"
                placeholder="Assign a team member"
                hide-details
                solo
                :items="users"
                class="default-input mb-4"
              />
            </v-flex>
            <v-flex xs6 class="pr-2">
              <div class="darkgrey--text">Tag</div>
              <v-select
                v-model="selectedTask.tag"
                hide-details
                solo
                placeholder="Select tag"
                :items="tags"
                class="default-input mb-4"
              />
            </v-flex>
            <v-flex xs6 class="pl-2">
              <div class="darkgrey--text">Due Date</div>
              <v-text-field
                class="default-input"
                type="date"
                solo
                hide-details
                v-model="selectedTask.due_date"
                placeholder="Choose a due date"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="default-input primary text-capitalize"
            @click="createTask()"
            :disabled="!taskSavable"
          >
            Add
          </v-btn>
          <v-btn
            outline
            class="default-input error--text text-capitalize"
            @click="createTaskDialogOpened = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="max-width: 1200px">
      <v-layout class="mb-4" align-center>
        <soraban-action-button
          @click="$router.go(-1)"
          icon="keyboard_arrow_left"
          help="Back"
        />
        <h1>Task Board</h1>
        <v-spacer />
        <div
          v-if="viewAll"
          @click="viewAll = false"
          class="darkgrey--text mr-4"
          style="cursor: pointer"
        >
          <v-icon color="darkgrey" size="18" class="mr-1">visibility</v-icon
          >View All
        </div>
        <div
          v-else
          @click="viewAll = true"
          class="darkgrey--text mr-4"
          style="cursor: pointer"
        >
          <v-icon color="darkgrey" size="18" class="mr-1">visibility</v-icon
          >View My Tasks
        </div>
        <div class="darkgrey--text mr-2" style="cursor: pointer">
          <v-icon color="darkgrey" size="20" class="mr-1">sort</v-icon>Sort By
        </div>
        <soraban-action-button
          @click="openCreateTaskDialog()"
          icon="add"
          help="Create Task"
        />
      </v-layout>
      <v-layout align-start>
        <v-flex
          xs3
          v-for="column in columns"
          :key="column.title"
          class="grey lighten-3 rounded-lg px-3 py-3 mx-2"
        >
          <!-- <v-chip class="subheading white--text" :class="column.class">{{column.title}}</v-chip> -->
          <div class="text-xs-left subheading darkgrey--text">
            {{ column.title }}
          </div>
          <!-- Draggable component comes from vuedraggable. It provides drag & drop functionality -->
          <draggable
            :list="column.tasks"
            :animation="200"
            ghost-class="ghost-card"
            group="tasks"
          >
            <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
            <v-card
              flat
              v-for="task in filteredTasks(column)"
              style="cursor: pointer"
              :key="task.id"
              class="mt-3 cursor-move"
              @click="selectTask(task)"
            >
              <v-card-title
                class="subheading font-weight-bold text-xs-left pb-0"
                ><span>{{ task.title }}</span></v-card-title
              >
              <v-card-text>
                <v-layout align-center class="mb-2">
                  <div class="darkgrey--text text-xs-right px-1 grey lighten-3">
                    {{ task.assigned_user }}
                  </div>
                  <v-spacer />
                  <v-icon
                    class="darkgrey--text caption mr-1"
                    v-if="task.due_date"
                    >calendar_today</v-icon
                  ><span class="darkgrey--text caption">{{
                    task.due_date
                  }}</span>
                </v-layout>
                <v-layout align-center class="text-xs-left">
                  <v-spacer />
                  <v-chip
                    class="white--text lighten-1"
                    v-if="task.tag"
                    small
                    :color="badgeColor(task)"
                    >{{ task.tag }}</v-chip
                  >
                </v-layout>
              </v-card-text>
            </v-card>
            <!-- </transition-group> -->
          </draggable>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import API from '@/api';
import take from 'lodash/take';
import union from 'lodash/union';
import intersection from 'lodash/intersection';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'TaskBoard',
  components: {
    draggable,
  },
  data() {
    return {
      viewAll: true,
      existRule: [v => !!v || 'Required'],
      taskStatuses: ['Not Started', 'In Progress', 'Need Review', 'Completed'],
      users: ['Enoch Ko', 'Jason Meadow', 'Sarah Connor'],
      tags: [
        'Tax Filing',
        'Review',
        'Compilation',
        'Administrative',
        '+ Create New',
      ],
      columns: [
        {
          title: 'Not Started',
          tasks: [
            {
              id: 1,
              title: 'Doe, John',
              due_date: '2021-08-13',
              tag: 'Tax Filing',
              status: 'Not Started',
              assigned_user: 'Enoch Ko',
              comments: [],
            },
            {
              id: 4,
              title: 'Super Cleaner LLC',
              due_date: '2021-09-14',
              tag: 'Tax Filing',
              status: 'Not Started',
              assigned_user: 'Jason Meadow',
              comments: [],
            },
          ],
        },
        {
          title: 'In Progress',
          tasks: [
            {
              id: 6,
              title: 'Timesheet Calculation',
              due_date: '2021-09-09',
              tag: 'Administrative',
              status: 'In Progress',
              assigned_user: 'Enoch Ko',
              comments: [
                {
                  user: 'Enoch Ko',
                  text: '@Deanne, I need your help on this',
                  date: moment().format('lll'),
                },
              ],
            },
            {
              id: 7,
              title: 'Wilson, Jake',
              due_date: '2021-09-14',
              tag: 'Tax Filing',
              status: 'In Progress',
              assigned_user: 'Jason Meadow',
              comments: [
                {
                  user: 'Enoch Ko',
                  text: '@Jason, Could you update the status?',
                  date: moment().format('lll'),
                },
              ],
            },
            {
              id: 8,
              title: 'King, Lauren',
              due_date: '2021-09-12',
              tag: 'Review',
              status: 'In Progress',
              assigned_user: 'Jason Meadow',
              comments: [],
            },
          ],
        },
        {
          title: 'Need Review',
          tasks: [
            {
              id: 11,
              title: 'Wong, Tiffany',
              due_date: '2021-09-02',
              tag: 'Tax Filing',
              status: 'Need Review',
              assigned_user: 'Jason Meadow',
              comments: [
                {
                  user: 'Jason Meadow',
                  text: '@Jaemin, Could you please review this?',
                  date: moment().format('lll'),
                },
              ],
            },
            {
              id: 12,
              title: 'Republic of Dishes, Inc. Compilation',
              due_date: '2021-09-10',
              tag: 'Compilation',
              status: 'Need Review',
              assigned_user: 'Sarah Connor',
              comments: [],
            },
          ],
        },
        {
          title: 'Completed',
          tasks: [
            {
              id: 14,
              title: 'Finn Tech Inc. Audit Draft',
              due_date: '2021-07-14',
              tag: 'Audit',
              status: 'Completed',
              assigned_user: 'Sarah Connor',
              comments: [],
            },
            {
              id: 15,
              title: 'ShopKart, LLC Compilation',
              due_date: '2021-08-01',
              tag: 'Compilation',
              status: 'Completed',
              assigned_user: 'Enoch Ko',
              comments: [],
            },
            {
              id: 16,
              title: 'Kelly, Thomas',
              due_date: '2021-09-14',
              tag: 'Tax Filing',
              status: 'Completed',
              assigned_user: 'Jason Meadow',
              comments: [],
            },
          ],
        },
      ],
      selectedTask: null,
      editTaskDialogOpened: false,
      createTaskDialogOpened: false,
      newComment: '',
      lastId: 17,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        ghostClass: 'ghost',
      };
    },
    ...mapGetters({
      currentUser: 'user',
      isAdvisor: 'isAdvisor',
    }),
    taskSavable() {
      return (
        !isEmpty(this.selectedTask.title) && !isEmpty(this.selectedTask.status)
      );
    },
  },
  methods: {
    isEmpty,
    moment,
    cloneDeep,
    union,
    intersection,
    selectTask(task) {
      this.selectedTask = task;
      this.editTaskDialogOpened = true;
    },
    filteredTasks(column) {
      if (this.viewAll) {
        return column.tasks;
      } else {
        return column.tasks.filter(
          d => d.assigned_user === this.currentUser.full_name,
        );
      }
    },
    openCreateTaskDialog() {
      this.selectedTask = {
        id: this.lastId,
        title: '',
        due_date: '',
        tag: null,
        status: null,
        assigned_user: null,
        comments: [],
      };
      this.createTaskDialogOpened = true;
    },
    deleteTask() {
      let column = this.columns.find(d => d.title === this.selectedTask.status);
      column.tasks.splice(
        column.tasks.findIndex(d => d.id === this.selectedTask.id),
        1,
      );
      this.editTaskDialogOpened = false;
    },
    createTask() {
      let column = this.columns.find(d => d.title === this.selectedTask.status);
      column.tasks.push(this.selectedTask);
      this.lastId = this.lastId + 1;
      this.createTaskDialogOpened = false;
    },
    badgeColor(task) {
      if (task.tag === 'Compilation') {
        return 'purple';
      } else if (task.tag === 'Tax Filing') {
        return 'blue';
      } else if (task.tag === 'Review') {
        return 'green';
      } else {
        return 'teal';
      }
    },
    addComment() {
      this.selectedTask.comments.push({
        user: this.currentUser.full_name,
        text: this.newComment,
        date: moment().format('lll'),
      });
      this.newComment = '';
    },
  },
  async created() {},
};
</script>

<style lang="css">
/* Unfortunately @apply cannot be setup in codesandbox,
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
  margin-bottom: 20px !important;
  margin-right: 0;
  margin-left: 0;
}
.list-group-item {
  cursor: move;
  border: solid 0.2px rgba(9, 30, 66, 0.06) !important;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 10px;
}
.list-group-item i {
  cursor: pointer;
}
.follow-up__question-container {
  border: solid 0.2px rgba(9, 30, 66, 0.06) !important;
  padding: 15px;
}
</style>
